import _ from 'lodash';
import { FALLBACK_COLOR_TO_SITE_COLOR_MAPPING, FALLBACK_FONT_TO_TEXT_PRESET_MAPPING, FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE } from './constants';
const findSiteColorByThemeName = (siteColors, themeName) => _.find(siteColors, color => color.reference === themeName);
const recoveryColorsMap = {
  thumbnailButtonsColor: 'rgba(255,255,255,1)',
  thumbnailOverlayColor: 'rgba(0,0,0,0.4)'
};
const withRecoveryColors = colors => _.mapValues(colors, function (_temp, key) {
  let {
    value,
    themeName
  } = _temp === void 0 ? {} : _temp;
  if (value && value.includes('NaN')) {
    return {
      themeName,
      value: recoveryColorsMap[key] || value
    };
  }
  return {
    value,
    themeName
  };
});
export const parseStyleParams = function (_ref, isResponsive) {
  let {
    styleParams,
    siteColors,
    siteTextPresets
  } = _ref;
  if (isResponsive === void 0) {
    isResponsive = false;
  }
  const {
    booleans,
    colors,
    numbers,
    fonts
  } = styleParams;
  const themeToSiteColorMapping = _(FALLBACK_COLOR_TO_SITE_COLOR_MAPPING).values().uniq().reduce((acc, themeName) => {
    const colorTheme = findSiteColorByThemeName(siteColors, themeName);
    return colorTheme ? {
      ...acc,
      [themeName]: {
        themeName,
        value: colorTheme.value
      }
    } : acc;
  }, {});
  const fallbackColors = _.mapValues(FALLBACK_COLOR_TO_SITE_COLOR_MAPPING, theme => themeToSiteColorMapping[theme]);
  const fallbackFonts = _.mapValues(isResponsive ? FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE : FALLBACK_FONT_TO_TEXT_PRESET_MAPPING, fontKey => {
    if (siteTextPresets[fontKey]) {
      const {
        fontFamily,
        value,
        size,
        style,
        weight,
        editorKey
      } = siteTextPresets[fontKey];
      return {
        editorKey,
        family: fontFamily,
        size: parseInt(size, 10),
        preset: fontKey,
        style: {
          bold: weight !== 'normal',
          italic: style === 'italic'
        },
        value
      };
    }
    return {};
  });
  const mappedColors = _.mapValues(colors, color => themeToSiteColorMapping[color.value] ? {
    ...color,
    value: themeToSiteColorMapping[color.value].value
  } : color);
  return {
    ...styleParams,
    booleans,
    colors: withRecoveryColors({
      ...fallbackColors,
      ...mappedColors
    }),
    numbers,
    fonts: {
      ...fallbackFonts,
      ...fonts
    }
  };
};
//# sourceMappingURL=parse.js.map